import React from 'react'
import { AgTechActionButton } from '@agtech/web/components/Buttons/AgTechButtons'
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu'
import { BidderRemovalButton } from '../buttons/SaleBidderButtons'
import ContactDialog from '@agtech/web/integrations/contacts/dialogs/ContactDialog'

export type BidderActionMenuProps = {
    bidderId: number,
    contactId?: number,
    bidderNumber?: string
}

const BidderActionMenu = (props: BidderActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Bidder">
                {props.contactId && <ContactDialog.Button contactId={props.contactId} text="View Contact" classes='eye' />}
                <BidderRemovalButton 
                    bidderId={props.bidderId}
                    bidderNumber={props.bidderNumber}
                />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
}

BidderActionMenu.Button = (props: BidderActionMenuProps) => (
    <AgTechActionButton>
        <BidderActionMenu {...props} />
    </AgTechActionButton>
)

export default BidderActionMenu